import { WarningIcon } from '@phosphor-icons/react'
import * as Dialog from '@radix-ui/react-dialog'
import type { Repository } from '../../utils/api-client/api-schemas.ts'
import { DefaultButton } from '../buttons/default-button.tsx'
import { GhostButton } from '../buttons/ghost-button.tsx'
import * as sharedStyles from '../drawers/workflow-shared.css.ts'
import { SCMIcon } from '../third-party-branding/scm-icon.tsx'

type AbandonWorkflowModalProps = {
  isOpen: boolean
  onOpenChange: (open: boolean) => unknown
  onAbandon: () => unknown
  repositoryType: Repository['type']
  repositoryDisplayName: string
  displayName: string
}

export const AbandonWorkflowModal: React.FC<AbandonWorkflowModalProps> = ({
  isOpen,
  onOpenChange,
  onAbandon,
  repositoryType,
  repositoryDisplayName,
  displayName,
}) => {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={sharedStyles.dialogOverlay} />
        <Dialog.Content className={sharedStyles.dialogContent}>
          <Dialog.Title className={sharedStyles.dialogTitle}>
            <WarningIcon className={sharedStyles.cautionIcon} size={32} weight="fill" aria-hidden={true} />
            Abandon workflow?
          </Dialog.Title>
          <div className={sharedStyles.dialogMiddle}>
            <Dialog.Description className={sharedStyles.dialogMessage}>
              You have a workflow in progress. How would you like to proceed?
            </Dialog.Description>
            <div className={sharedStyles.dialogSubtitle}>
              <div className={sharedStyles.dialogRepoInfo}>
                <SCMIcon type={repositoryType} size="medium" />
                <span>{repositoryDisplayName}</span>
              </div>
              <div className={sharedStyles.workflowName}>{displayName}</div>
            </div>
          </div>
          <div className={sharedStyles.dialogButtons}>
            <GhostButton type="secondary" onClick={() => onOpenChange(false)}>
              Cancel
            </GhostButton>
            <DefaultButton
              buttonType="secondary"
              onClick={() => {
                onOpenChange(false)
                onAbandon()
              }}
            >
              Abandon
            </DefaultButton>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
